import { envVars } from '@/envVars';

const redirect = (url: string): void => {
  window.location.assign(url);
};

const redirectToLeadFormAuto = (): void => {
  redirect(envVars.LEAD_FORM_AUTO_DOMAIN_NAME);
};

const redirectToLeadFormHome = (): void => {
  redirect(envVars.LEAD_FORM_HOME_DOMAIN_NAME);
};

const redirectToLeadReviewAuto = (): void => {
  redirect(envVars.URL_LEAD_REVIEW_AUTO);
};

const redirectToLeadReviewHome = (): void => {
  redirect(envVars.URL_LEAD_REVIEW_HOME);
};

const redirectToLogin = (): void => {
  redirect(envVars.LOGIN_URL);
};

const redirectToPayroll = (): void => {
  redirect(envVars.URL_PAYROLL);
};

const redirectToHomeRefi = (): void => {
  redirect(envVars.URL_HOME_REFI_TIMELINE);
};

const redirectToAutoEquity = (): void => {
  redirect(envVars.URL_AUTO_EQUITY);
};

export {
  redirect,
  redirectToLogin,
  redirectToLeadFormAuto,
  redirectToLeadFormHome,
  redirectToLeadReviewAuto,
  redirectToLeadReviewHome,
  redirectToPayroll,
  redirectToHomeRefi,
  redirectToAutoEquity,
};
